import template from './modal.html';

export const uiModalComponent = {
  name: 'uiModalComponent',
  controller: ($transclude) => {
    'ngInject';

    const noActions = () => {
      return !$transclude.isSlotFilled('actions');
    };

    return { noActions };
  },
  controllerAs: 'vm',
  template,
  transclude: {
    content: '?content',
    actions: '?actions'
  }
};



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-modal/src/modal.component.js